import React, { useState } from "react"
import { Button, Card, Space, Tabs } from "antd"
import { CodeOutlined, EyeOutlined } from "@ant-design/icons"

const CodePreviewSwitch = ({ setIsPreview, isPreview }) => {
    const onChange = (key) => {
        setIsPreview(key == 1)
    }

    return (
        <div
            style={{
                padding: "0 0 0 10px",
                background: "#1e1e1e",
                borderRadius: "8px",
                padding: "8px",
                border: "1px solid #333",
            }}
        >
            {/* Switch Buttons */}
            <Space style={{ backgroundColor: "#1e1e1e" }}>
                <Tabs
                    onChange={onChange}
                    items={[
                        {
                            label: "ویرایش",
                            icon: <CodeOutlined />,
                            key: "2",
                        },
                        {
                            label: "پیش نمایش",
                            icon: <EyeOutlined />,
                            key: "1",
                        },
                    ]}
                    // Add dark mode styling to Tabs
                    tabBarStyle={{
                        borderBottom: "none",
                        marginBottom: 0,
                    }}
                    // Custom styling for dark mode
                    style={{
                        backgroundColor: "#1e1e1e",
                    }}
                />
            </Space>
        </div>
    )
}

export default CodePreviewSwitch
